import { getChamberList } from "src/aadeCase/data-access/gateway";
import { useQuery } from "react-query";
import { useAuth } from "src/shared/context/useAuth";

export default function useGetOrganizations() {
  const { isSystemAdmin } = useAuth();
  return useQuery({
    queryFn: getChamberList,
    queryKey: "organizations",
    enabled: isSystemAdmin,
  });
}
